import { ExclamationCircleTwoTone } from '@ant-design/icons';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import { getAlphaColor } from '@/styles/colors/color.utils';
import type { FeedbackSentiment } from '@/types/feedbackConst';

type Props = {
  sentence: FeedbackSentenceT;
};

const RawTextSentimentItem = (props: Props) => {
  const color = useColor();
  const sentence = props.sentence;
  return (
    <Wrapper
      sentiment={sentence.sentiment}
      a="center"
      className="wrapper"
      primary={sentence.primary}
    >
      <div className="sentiment"></div>
      <div className="sentence">
        {sentence.primary && (
          <ExclamationCircleTwoTone
            twoToneColor={[
              color.sentiment[sentence?.sentiment || 2],
              getAlphaColor(color.sentiment[sentence?.sentiment || 2], 0.1),
            ]}
            style={{ fontSize: 16, marginBottom: 8 }}
          />
        )}
        <Typo type="body2" color={color.gray700}>
          {sentence.text}
        </Typo>
      </div>
    </Wrapper>
  );
};

type StyleProps = {
  sentiment: FeedbackSentiment;
  primary?: boolean;
};

const Wrapper = styled(Flex)<StyleProps>`
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  border: 1px solid
    ${({ primary, theme, sentiment }) =>
      primary ? theme.colors.sentiment[sentiment] : 'transparent'};
  background-color: ${({ theme, sentiment }) =>
    getAlphaColor(theme.colors.sentiment[sentiment], 0.05)};

  transition: all 0.2s;

  &:hover {
    background-color: ${({ theme, sentiment }) =>
      getAlphaColor(theme.colors.sentiment[sentiment], 0.1)};
  }

  .sentiment {
    width: 8px;
    background-color: ${({ theme, sentiment }) =>
      theme.colors.sentiment[sentiment]};
    min-width: 8px;
    align-self: stretch;
  }

  .sentence {
    padding: 8px 16px;
    flex: 1;
    word-break: break-all;
  }
`;

export default RawTextSentimentItem;
